<script setup>
import Layout from '../../Layouts/Guest.vue';
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import { Head, useForm } from "@inertiajs/inertia-vue3";

const props = defineProps([
    'status'
]);


const form = useForm({
    email: '',
});

const submit = () => {
    form.post('/forgot-password', {
        onSuccess: () => {
            form.email = null
        }
    });
};
</script>

<template>
    <Layout>
        <Head title="Forgot Password" />

        <div class="max-w-[600px] flex-1">
            <h3 class="text-2xl text-primary mb-1">Passwort vergessen?</h3>

            <p>Gib uns einfach deine E-Mail-Adresse an, und wir senden dir einen Link zum Zurücksetzen deines Passworts, mit dem du ein neues wählen kannst.</p>

            <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
                {{ status }}
            </div>

            <form @submit.prevent="submit">
                <div class="my-4">
                    <InputText v-model="form.email"
                               type="email"
                               class=" w-full"
                               placeholder="E-Mail-Adresse"
                               required/>

                    <span v-if="form.errors.email" class="text-error text-sm">
                        {{ form.errors.email[0] }}
                    </span>
                </div>

                <div>
                    <Button
                        :disabled="form.processing"
                        :loading="form.processing"
                        type="submit"
                        class="w-full bg-[#FFF053] text-black border-none cursor-pointer"
                        label="Passwort-Zurücksetzungslink per E-Mail senden"
                    />
                </div>
            </form>
        </div>
    </Layout>
</template>
